
const setLocationFormat = ({ state, city, city_id, latitude, longitude, coordinates = [], ...rest }) => {
  const [lat, lng] = coordinates
  return {
    state,
    state_code: rest?.state_id || null,
    city,
    city_id,
    latitude: lat || latitude,
    longitude: lng || longitude
  }
}
export const setPayload = ({
  originLocations,
  destinationLocations,
  equipmentsTypes,
  from,
  manageStatus,
  movementNumber,
  radius
}) => {
  const payload = {}

  if (movementNumber) {
    payload.orderNumber = movementNumber
    return payload
  }

  if (originLocations?.length) {
    payload.origin = originLocations.map(setLocationFormat)
  }

  if (destinationLocations?.length) {
    payload.destination = destinationLocations.map(setLocationFormat)
  }

  if (from?.value && radius?.value) {
    payload.radius = { from: from?.value, distance: radius?.value || 0 }
  }

  if (equipmentsTypes?.length) {
    payload.equipment_type = equipmentsTypes.map(equipment => equipment.equipment_code)
  }

  if (manageStatus.length) {
    payload.manageStatus = manageStatus.length >= 2 ? 'all' : manageStatus[0]
  }

  return payload
}

const errorNotify = (error, message, notApply = false) => ({ error, message, notApply })

export const validateFilters = ({
  originLocations,
  destinationLocations,
  from,
  radius,
  equipmentsTypes
}) => {
  if (from?.from === 'Destination' && radius?.radius && !destinationLocations.length) {
    return errorNotify(true, 'Unable to filter with radius from destination if an destination is not selected')
  }

  if (from?.from === 'Origin' && radius?.radius && !originLocations.length) {
    return errorNotify(true, 'Unable to filter with radius from origin if an origin is not selected')
  }

  if (from?.from === 'Both' && radius?.radius && (!originLocations?.length || !destinationLocations?.length)) {
    return errorNotify(true, 'Unable to filter with radius from both if origin and destination are not selected')
  }

  if (!originLocations.length && !destinationLocations.length && !radius?.radius && from?.from && !equipmentsTypes.length) {
    return errorNotify(false, null, true)
  }

  return errorNotify(false, null)
}
